import React, { FC } from 'react';
import { useSetState } from 'react-use';
import FormInput from '../../../bulma/FormInput';
import authService from '../../../services/auth.service';
import { LoginRes } from '../../../types/connection.types';
import { useSiteTranslation } from '../../../utils/translations';

type PasswordConnectionProps = {
  onLogin: (user: LoginRes) => void;
};

const PasswordConnection: FC<PasswordConnectionProps> = ({ onLogin }) => {
  const [{ email, password }, setState] = useSetState({ email: '', password: '' });
  const { t } = useSiteTranslation();

  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    const loginRes = await authService.login(email, password);
    if (loginRes.success) {
      onLogin(loginRes);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setState({ [name]: value });
  };

  return (
    <>
      <form action="" onSubmit={handleSubmit}>
        <FormInput
          type="string"
          value={email}
          name="email"
          icon="fa-envelope"
          onChange={handleChange}
          label={t('fields.email') as string}
        />
        <FormInput
          type="string"
          placeholder="****"
          value={password}
          name="password"
          icon="fa-lock"
          onChange={handleChange}
          label={t('fields.password') as string}
        />
        <div className="field">
          <button disabled={!email || !password} className="button is-primary is-fullwidth">
            {t('fields.login')}
          </button>
        </div>
      </form>
    </>
  );
};

export default PasswordConnection;
